import { NgClass, NgFor, NgIf } from '@angular/common';
import {
  Component,
  Output,
  EventEmitter,
  ElementRef,
  HostListener,
} from '@angular/core';
import { RouterLink } from '@angular/router';
import { GlobalService } from '../../_services/global.service';
import { TooltipModule } from 'primeng/tooltip';

@Component({
  selector: 'app-sidebar',
  standalone: true,
  imports: [NgFor, NgClass, NgIf, NgClass, RouterLink, TooltipModule],
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.scss',
})
export class SidebarComponent {
  @Output() headingEvent = new EventEmitter<string>();
  @Output() toggleSidebarEvent = new EventEmitter<boolean>();
  menu_list: any = [];
  showMenuList: boolean = false;
  selected_menu_index = 0;
  toggle_sidebar = true;
  icon_base_url = '/assets/icons/';

  constructor(
    private globalService: GlobalService,
    private elementRef: ElementRef
  ) { }

  ngOnInit() {
    this.globalService.getMenuIndex().subscribe((val) => {
      // console.log("-------Rxjs------- ",val )
      this.selected_menu_index = val;
      this.get_menu_list();
    });
  }

  get_menu_list() {
    this.menu_list = [];
    this.menu_list.push({
      title: 'Search',
      logo: 'search.png',
      selected_logo: 'search_orange.png',
      link: '/',
      route: 'inside',
    });
    this.menu_list.push({
      title: 'IPD Updates',
      logo: 'update.png',
      selected_logo: 'ipdpatent.png',
      link: '/ipd',
      route: 'inside',
    });
    this.menu_list.push({
      title: 'Support',
      logo: 'support_black.png',
      selected_logo: 'support_orange.png',
      link: '/support',
      route: 'inside',
    });

    this.select_menu(this.selected_menu_index);
  }

  select_menu(i: number) {
    // console.log('Selected Menu Index : ', i);
    this.selected_menu_index = i;
    this.headingEvent.emit(
      this.menu_list
        .filter((val: any, index: number) => i === index)
        .map((val: any) => val.title)[0]
    );
  }
  toggleMenuList() {
    this.showMenuList = !this.showMenuList;
  }
  toggleSidebar() {
    this.toggle_sidebar = !this.toggle_sidebar;
    this.toggleSidebarEvent.emit(this.toggle_sidebar);
  }
  closeMenuList() {
    if (this.showMenuList) {
      this.showMenuList = false;
    }
  }
  hideMenuList() {
    this.showMenuList = false;
  }

  @HostListener('document:click', ['$event'])
  clickOutside(event: Event) {
    if (!this.elementRef.nativeElement.contains(event.target)) {
      this.closeMenuList();
    }
  }
}
